
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_14908_488106)","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10.773 4.232H2.945c-.72 0-1.304.48-1.304 1.072v9.649c0 .592.584 1.072 1.304 1.072h7.828c.721 0 1.305-.48 1.305-1.072V5.304c0-.592-.584-1.072-1.305-1.072zM4.086 7.09H9.79M4.086 9.947H9.79M4.086 12.805h2.853"}}),_c('path',{attrs:{"d":"M5.79 1.947h7.428c.303 0 .593.115.808.32.214.203.335.48.335.769v10.34"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_14908_488106"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .988)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    